export default __webpack_public_path__ + "static/media/Pandava_Caves_@_Pachmarhi.1182e487.jpg";